import React, { Component } from 'react';

export class VkRedWidgetComponent extends React.Component {

    constructor(props) {
        super(props);
        this.refFileInputSmallImg = React.createRef();
        this.refFileInputBigImg = React.createRef();
    }

    render() {
        return (
            <div className='editBlock'>  
            <div className='editBlock_name'>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                fill="none"
                viewBox="0 0 13 13"
                >
                <circle
                    cx="6.5"
                    cy="6.5"
                    r="6.5"
                    fill="url(#paint0_linear_35_1449)"
                ></circle>
                <defs>
                    <linearGradient
                    id="paint0_linear_35_1449"
                    x1="11.315"
                    x2="6.5"
                    y1="5.056"
                    y2="13"
                    gradientUnits="userSpaceOnUse"
                    >
                    <stop stopColor="#0767F4"></stop>
                    <stop offset="1" stopColor="#30D1E0"></stop>
                    </linearGradient>
                </defs>
                </svg>
            
            Редактировать виджет
            </div>

            <div className= 'inputsBlock'>
                        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label'>
        
                    Загрузите фото, которое будет показываться на сайте при просмотре с большого экрана(ПК, ноутбук и т.д.).
                    Рекомендуемое разрешение 1792х1509px
                    </div>
        
                    <div onClick={(e) => {
                            this.refFileInputBigImg.current.click()
                        }}  className='inputsBlock_block_addPhoto'>
                        { this.props.big_img_src == null ? 
                        <span className='plusIcon'> + </span> 
                        : 
                        <img src={this.props.big_img_src}/>} 
                    </div>
                    
                    <input onChange={this.props.handleInputChange_bigImg} 
                    className='hidden' 
                    ref={this.refFileInputBigImg} 
                    type='file' />
        
            </div>
        
        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label'>
        
                    Загрузите фото, которое будет показываться на сайте при просмотре с телефона.
                    Рекомендуемое разрешение 400x220px
                    </div>
        
                    <div onClick={(e) => {
                            this.refFileInputSmallImg.current.click()
                        }}  className='inputsBlock_block_addPhoto'>
                        { this.props.small_img_src == null ? 
                        <span className='plusIcon'> + </span> 
                        : 
                        <img src={this.props.small_img_src}/>} 
                    </div>
                    
                    <input onChange={this.props.handleInputChange_smallImg} className='hidden' ref={this.refFileInputSmallImg} type='file' />
        
            </div>
        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label'>
        
                    Введите текст, который выдается пользователю чат-ботом после проверки подписки.
                    </div>
        
                    <textarea
                        onChange={this.props.updatePrize} 
                        value={this.props.prize} 
                        style={{height: '50px'}}> 
        
                    </textarea>
        
        
            </div>
            {/*<div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label'>
        
                    Назовите страницу, чтобы проверять статистику
                    </div>
        
                    <input type='text' />
        
        
                </div> */ }
        
        
            <div className= 'inputsBlock_block'>
                    <div className= 'inputsBlock_block_label'>
        
                    Введите заголовок страницы
                    </div>
        
                    <textarea  
                    onChange={this.props.updateHeader} 
                     value={this.props.header_text} 
                      style={{height: '50px'}}> 
        
                    </textarea>
        
        
            </div>
        
            <div className= 'inputsBlock_block' style={{ marginTop: '20px'}}>
                    <div className= 'inputsBlock_block_label'>
        
                        Введите основной текст
                    </div>
        
                    <textarea onChange={this.props.updateMain} value={this.props.main_text} style={{height: '130px'}}> 
        
                    </textarea>
        
        
            </div>
        
            <div className= 'inputsBlock_block' style={{ marginTop: '20px'}}>
                    <div className= 'inputsBlock_block_label'>
        
                        Через сколько секунд после открытия сайта показывать виджет:
                    </div>
        
                    <input value={this.props.timeout} onChange={this.props.updateTimeout} type='number' min='0' max='30' />
        
        
            </div>
            
            
            <div className= 'inputsBlock_block saveBlock'>
                    <a href='#'  
                    onClick={(e) => {
                        this.props.setShowPreview(e, true)
                    }
                    } className='bigButton'> Посмотреть </a>
                    <a href='#' onClick={(e) => {
                        
                        this.props.doSave(e)
                    }
                    } className='bigButton'>Сохранить и продолжить</a>
                    {/*<div className="finishButton">
                            <a href='#'> Завершить редактирование </a>
                        </div> */}
                    
            </div>
            
        
        </div>  
        </div>
        )
                
    }
}